/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationResourceDetails {
    getFixupPrototypeFunction() { return ScheduleRecommendationResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationResourceDetails>): ScheduleRecommendationResourceDetails {
        let obj = Object.assign(new ScheduleRecommendationResourceDetails(), model);
        ScheduleRecommendationResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationResourceDetails>): ScheduleRecommendationResourceDetails {
        if (!model) return null;
        return ScheduleRecommendationResourceDetails.newInstance(<ScheduleRecommendationResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationResourceDetails) {
        if (!obj) return;

        models.ScheduleRecommendationResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationResourceDetails): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.potential_cost_savings_daily === undefined) {
            this.potential_cost_savings_daily = 0;
        }
        if (this.potential_cost_savings_monthly === undefined) {
            this.potential_cost_savings_monthly = 0;
        }
        if (this.potential_cost_savings_yearly === undefined) {
            this.potential_cost_savings_yearly = 0;
        }
        if (typeof this.from_time === "string") {
            this.from_time = new Date(<string><any>this.from_time);
        }
        if (typeof this.to_time === "string") {
            this.to_time = new Date(<string><any>this.to_time);
        }
    }

    /**
     * Currency
     */
    currency: models.Currency;

    /**
     * Name of the resource
     */
    resource: string;

    /**
     * Name of the resource component
     */
    resource_type: string;

    /**
     * Daily Cost Savings of the Recommendation
     */
    potential_cost_savings_daily: number;

    /**
     * Monthly Cost Savings of the Recommendation
     */
    potential_cost_savings_monthly: number;

    /**
     * Yearly Cost Savings of the Recommendation
     */
    potential_cost_savings_yearly: number;

    /**
     * Schedule Finding Type
     */
    schedule_finding: models.ScheduleFinding;

    /**
     * Recommendation Id
     */
    recommendation_id: string;

    /**
     * If set indicates remediation action should be shown
     */
    show_remediation_action: boolean;

    /**
     * Schedule Recommendation Statistical Method Name
     */
    statistical_method: models.ScheduleRecommendationStatisticalMethod;

    /**
     * List of from_times or days for the recommendation
     */
    schedule_periods: Array<string>;

    /**
     * Schedule status of the recommendation
     */
    schedule_status: string;

    day: models.DayOfWeek;

    /**
     * Schedule Start Time
     */
    from_time: Date;

    /**
     * Schedule End Time
     */
    to_time: Date;

}
